import http from '../http';

/**
 * 고객사 원료명칭 목록 조회
 * @param {Object} params - 검색 조건 (customerMaterialName, internalMaterialName, currentPage, pageSize)
 * @returns {Promise} API 응답
 */
export const customerMaterialNameList = params => {
  return http.post('/api/v1/customermaterialname/list', params);
};

/**
 * 고객사 원료명칭 상세 조회
 * @param {number} id - 고객사 원료명칭 ID
 * @returns {Promise} API 응답
 */
export const customerMaterialNameDetail = id => {
  return http.get(`/api/v1/customermaterialname/detail/${id}`);
};

/**
 * 고객사 원료명칭 등록
 * @param {Object} data - 등록할 고객사 원료명칭 데이터
 * @returns {Promise} API 응답
 */
export const customerMaterialNameInsert = data => {
  return http.post('/api/v1/customermaterialname/insert', data);
};

/**
 * 고객사 원료명칭 수정
 * @param {number} id - 고객사 원료명칭 ID
 * @param {Object} data - 수정할 고객사 원료명칭 데이터
 * @returns {Promise} API 응답
 */
export const customerMaterialNameUpdate = data => {
  return http.post('/api/v1/customermaterialname/update', data);
};

/**
 * 고객사 원료명칭 삭제
 * @param {number} id - 고객사 원료명칭 ID
 * @returns {Promise} API 응답
 */
export const customerMaterialNameDelete = id => {
  return http.delete(`/api/v1/customermaterialname/delete/${id}`);
};

/**
 * 사내통용 원료명칭 검색 (Subs_Index 테이블의 rmav 컬럼)
 * @param {Object} params - 검색 조건 (searchKeyword, currentPage, pageSize)
 * @returns {Promise} API 응답
 */
export const searchInternalMaterialNames = params => {
  return http.post('/api/v1/subsIndex/searchInternalMaterialNames', params);
};
